export type SurveyTimePeriod =
  | 'allTime'
  | 'last7days'
  | 'last30days'
  | 'last90days'
  | 'last365days'
  | 'custom';

export type SurveyTimePeriodFilterValue = {
  timePeriod: SurveyTimePeriod;
  startDateInterval: string | null;
  endDateInterval: string | null;
};

export const DEFAULT_SURVEY_TIME_PERIOD: SurveyTimePeriod = 'allTime';
